/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
import 'react-datepicker/dist/react-datepicker.css';
import './loans/Loans.scss';
import React, { useState, useEffect, useMemo } from 'react';
// packages
import { connect } from 'react-redux';
import { DatePicker, Input, Button } from 'rsuite';
// page helpers
import LoansColumns from './loans/LoansColumns';
import { parseLoans } from './loans/LoansHelpers';
// page dialogs
import ValidateCVU from './loans/dialogs/ValidateCVU';
import { UploadBillDialog } from './loans/dialogs/UploadBillDialog';
import { ResendSMS } from './loans/dialogs/ResendSMS';
import { CreateSellerDialog } from './loans/dialogs/CreateSellerDialog';
import CreateNewLoan from './loans/dialogs/CreateNewLoan';
import { ConfirmLoan } from './loans/dialogs/ConfirmLoan';
// services
import { cuotitasStoreService } from '../services';
// helpers
import { alert } from '../helpers/rsuite/Alerts';
import { errorMapper } from '../helpers/ErrorMappers';
import { dateFns, FilterQueryParams } from '../helpers';
// constants
import allRoles from '../constants/roles/roles';
import STATUS_LOAN from '../constants/loans/statusesRequest';
import loanStatuses from '../constants/loans/statuses';
import ENABLE from '../constants/enable';
// components
import Tabs, { useTabs } from '../components/tabs/Tabs.jsx';
import { Table } from '../components/table/Table';
import useNotifications from '../hooks/useNotifications.js';
// import Button from '../components/button/Button.jsx';
/* eslint-disable-next-line no-unused-vars */
import { billRequestMock, loansRequestMock } from '../constants/mocks/examples';

// import useNotifications from './LoansNotifications';

export const sortedKeyMap = { created_at_time: 'created_at', order: 'desc' };
export const defaultSorted = [{ dataField: 'created_at', order: 'desc' }];

const TABS = {
    1: 'pending',
    2: 'sent',
    3: 'success',
    4: 'cancelled',
    5: 'rejected',
    6: 'liquidated',
    7: 'observed'
};

const subrows = {
    row: [
        {
            dataField: 'detailRequirement',
            text: 'Requisito detalle',
        },
        {
            dataField: 'observation',
            text: 'Observacion',
        },
    ],
    format: '',
    showExpandColumn: false,
    expandColumnPosition: 'left'
};

function parseDate (date) {
    if (!date) {
        return { startAt: '', endAt: '' };
    }

    let startAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
    startAt = dateFns.format(new Date(startAt.getTime() + (startAt.getTimezoneOffset() * 60 * 1000)), 'y-MM-dd HH:mm:ss');

    let endAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 23:59:59'), 'y-MM-dd HH:mm:ss');
    endAt = dateFns.format(new Date(endAt.getTime() + (endAt.getTimezoneOffset() * 60 * 1000)), 'y-MM-dd HH:mm:ss');

    return { startAt, endAt };
};

export function Loans ({ user }) {
    // constants

    const sortField = 'created_at';
    const sortOrder = 'desc';

    // state

    const [loading, setLoading] = useState(false);

    const [inputSearch, setInputSearch] = useState('');
    const [inputDate, setInputDate] = useState(null);

    const [filterSearch, setFilterSearch] = useState('');
    const [filterDate, setFilterDate] = useState(null);

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [loanList, setLoanList] = useState([]);
    const [loanId, setLoanId] = useState();

    const [store, setStore] = useState();

    const [dialogBillUploadShow, setDialogBillUploadShow] = useState(false);
    const [dialogCvuValidationShow, setDialogCvuValidationShow] = useState(false);
    const [dialogLoanConfirmationShow, setDialogLoanConfirmationShow] = useState(false);
    const [dialogLoanCreationShow, setDialogLoanCreationShow] = useState(false);
    const [dialogSellerCreationShow, setDialogSellerCreationShow] = useState(false);
    const [dialogSmsResendShow, setDialogSmsResendShow] = useState(false);

    // hooks

    const tabs = useTabs([
        { id: 1, name: 'pending', label: 'Pendientes' },
        { id: 3, name: 'success', label: 'Exitosos' },
        { id: 4, name: 'cancelled', label: 'Anulados' },
        { id: 5, name: 'rejected', label: 'Rechazados' },
        { id: 6, name: 'liquidated', label: 'Liquidados' },
        { id: 7, name: 'observed', label: 'Observados' },
    ]);

    const notifications = useNotifications({ store });

    // computed properties

    const isAdmin = useMemo(() => {
        for (const role of user?.roles) {
            if (role.role.id === allRoles['admin.digital-origination']) {
                return true;
            }
        }
        return false;
    }, [user]);

    const loan = useMemo(() => {
        return loanList.find(loan => loan.id === loanId) || {};
    }, [loanId]);

    // actions

    async function filter () {
        try {
            setLoading(true);

            const options = {
                order: `${sortField}-${sortOrder.toUpperCase()}`,
                page: pageNumber,
                pageSize: pageSize,
            };

            const billFilters = new FilterQueryParams();
            const loanFilters = new FilterQueryParams();

            billFilters.equal('idStore', store.id);
            billFilters.equal('id_loan_request_status', tabs.selected.id);
            loanFilters.equal('loan_request.id_loan_request_status', tabs.selected.id);

            if (inputDate) {
                const { startAt, endAt } = parseDate(inputDate);
                billFilters.equal('created_at', startAt);
                loanFilters.between('created_at', startAt, endAt);
            }

            if (inputSearch && !parseInt(inputSearch)) {
                loanFilters.like('person.attributes.description', `${inputSearch.toUpperCase().trim()}`);
            }

            if (inputSearch && !!parseInt(inputSearch)) {
                loanFilters.equal('person.documents.description', inputSearch.trim());
            }

            const loanOptions = { ...options, filters: loanFilters.build() };
            const billOptions = { ...options, filters: billFilters.build() };

            // get loans and bills
            const loans = await cuotitasStoreService.getStoreLoans(store.id, loanOptions);
            const bills = await cuotitasStoreService.getRequestsList(billOptions);

            /* Mock to fill table of loans and bills */
            // const loans = loansRequestMock;
            // const bills = billRequestMock;

            // parse them
            const loansParsed = parseLoans(loans, bills, loanStatuses);

            setLoanList(loansParsed);
        }
        catch (error) {
            const msg = errorMapper(error);
            error.msg = msg;
            alert(msg?.type, msg?.message, 0, 'topCenter');
        }
        finally {
            setLoading(false);
        }
    };

    async function findStore () {
        const stores = await cuotitasStoreService.getStores();
        localStorage.setItem('store', JSON.stringify(stores[0]));
        setStore(stores[0]);
    };

    async function findCheckbook (loanRequestId, creditNumber) {
        alert('success', `Descargando la chequera para el prestamo ${creditNumber}...`);
        return cuotitasStoreService.getLoanRequestCheckbook(loanRequestId, TABS[tabs.selected.id])
            .then(checkbook => {
                const downloadLink = document.createElement('a');
                downloadLink.href = `data:application/pdf;base64,${checkbook}`;
                downloadLink.download = `chequera_${creditNumber}.pdf`;
                downloadLink.click();
                alert('success', 'La chequera fue descargada con éxito');
            })
            .catch(error => {
                error = errorMapper(error);
                alert('error', error.message);
            });
    };

    // events

    function onTabChange (tab) {
        if (tab.id === STATUS_LOAN.observed) {
            subrows.showExpandColumn = true;
            notifications.clearChanges('observed');
        }
        else {
            subrows.showExpandColumn = false;
        }
        tabs.setSelected(tab);
        setPageNumber(1);
    }

    function onSearchSubmit (event) {
        event.preventDefault();
        setFilterSearch(inputSearch);
        setFilterDate(inputDate);
        setPageNumber(1);
    }

    function onTableChange (tableParams) {
        const { pageNumber, pageSize } = tableParams();
        setPageNumber(pageNumber);
        setPageSize(pageSize);
    }

    function onButtonLoanCreationClick () {
        setDialogLoanCreationShow(true);
    };

    function onButtonCvuValidationClick () {
        setDialogCvuValidationShow(true);
    };

    function onButtonSellerCreationClick () {
        setDialogSellerCreationShow(true);
    };

    function onButtonBillUploadClick (id) {
        setLoanId(id);
        setDialogBillUploadShow(true);
    };

    function onButtonSmsResendClick (id) {
        setLoanId(id);
        setDialogSmsResendShow(true);
    };

    function onButtonLoanConfirmationClick (id) {
        setLoanId(id);
        setDialogLoanConfirmationShow(true);
    };

    function onDialogClose () {
        setLoanId(0);
        setDialogBillUploadShow(false);
        setDialogCvuValidationShow(false);
        setDialogLoanConfirmationShow(false);
        setDialogLoanCreationShow(false);
        setDialogSellerCreationShow(false);
        setDialogSmsResendShow(false);
        filter();
    };

    useEffect(() => {
        if (!store) return;
        filter();
    }, [
        tabs.selected,
        inputDate,
        filterDate,
        filterSearch,
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
        store
    ]);

    useEffect(() => {
        tabs.setPopover('observed', notifications.changes.observed.length);
        if (tabs.selected.name === 'observed' && notifications.changes.observed.length > 0) {
            notifications.clearChanges('observed');
            filter();
        }
    }, [notifications.changes.observed]);

    useEffect(() => {
        findStore();
    }, []);

    return (
        <main id='Loans' className='loans card'>
            <header className='loans-header'>
                <Tabs
                    className='loans-tabs'
                    schema={tabs.schema}
                    selected={tabs.selected}
                    onSelect={onTabChange}
                />
                <div className="loans-toolbar">
                    <form id="LoansForm" className='loans-toolbar-search' onSubmit={onSearchSubmit}>
                        <Input
                            name='searchbar'
                            placeholder="Buscar por nombre o DNI"
                            className='searchbar'
                            appearance='subtle'
                            style={{ width: 300 }}
                            value={inputSearch}
                            onChange={setInputSearch}
                        />
                        <DatePicker
                            className='datePicker'
                            format="dd/MM/yyyy"
                            block={true}
                            oneTap
                            style={{ width: 150 }}
                            size='md'
                            placeholder= 'Fecha de Alta'
                            limitEndYear={2020}
                            value={inputDate}
                            onChange={setInputDate}
                            onInput={(event) => ['_/__/____', ''].includes(event.target.value) && setInputDate(null)}
                            onClean={() => setInputDate(null)}
                        />
                    </form>
                    <div className='loans-toolbar-actions'>
                        <Button appearance='primary' type='submit' form='LoansForm' loading={loading}>
                            Buscar
                        </Button>
                        <Button appearance='primary' onClick={onButtonLoanCreationClick}>
                            Nuevo Prestamo
                        </Button>
                        {ENABLE?.validateCVU && <Button appearance='primary' onClick={onButtonCvuValidationClick}>
                            Validar CBU/CVU/Alias
                        </Button>}
                        {isAdmin && <Button appearance='primary' onClick={onButtonSellerCreationClick}>
                            Crear usuario vendedor
                        </Button>}
                    </div>
                </div>
            </header>
            <div className="loans-content">
                <Table
                    data={loading ? [] : loanList}
                    columns={LoansColumns({ downloadCheckbook: findCheckbook, openModalUploadBill: onButtonBillUploadClick, openModalConfirmLoan: onButtonLoanConfirmationClick, openModalResendSMS: onButtonSmsResendClick, tabs: tabs.selected.id })}
                    sort={defaultSorted}
                    onChange={onTableChange}
                    isLoading={loading}
                    pagination={{
                        sizePerPage: pageSize,
                        page: pageNumber,
                    }}
                    subrows={subrows}
                />
            </div>
            {(isAdmin && dialogSellerCreationShow) && <CreateSellerDialog
                show={dialogSellerCreationShow}
                onHide={onDialogClose}
            />}
            {dialogLoanCreationShow && <CreateNewLoan
                show={dialogLoanCreationShow}
                onHide={onDialogClose}
            />}
            {dialogCvuValidationShow && <ValidateCVU
                show={dialogCvuValidationShow}
                onHide={onDialogClose}
            />}
            {dialogBillUploadShow && <UploadBillDialog
                fetchCards={() => filter()}
                show={dialogBillUploadShow}
                onHide={onDialogClose}
                tab={TABS[tabs.selected.id]}
                loan={loan}
            />}
            {dialogLoanConfirmationShow && <ConfirmLoan
                fetchCards={() => filter()}
                show={dialogLoanConfirmationShow}
                request={loan}
                onHide={onDialogClose}
                tab={TABS[tabs.selected.id]}
                id={loanId}
            />}
            {dialogSmsResendShow && <ResendSMS
                show={dialogSmsResendShow}
                onHide={onDialogClose}
                tab={TABS[tabs.selected.id]}
                id={loanId}
                hash={loan.signHash}
                idSignRequest={loan.signID}
                telephone={loan.cellPhone}
            />}
        </main>
    );
}

export default connect(({ auth: { user } }) => ({ user }))(React.memo(Loans));
